const contracts = require('@baza/protocol/baza.json')

module.exports = contracts
